import { css, CSSResult, unsafeCSS } from 'lit';
import { spacing } from '@thiememeulenhoff/lit-sdk';
import { BreakpointSmall } from '@thiememeulenhoff/tokens/core';
import { tagName } from '../../../helpers/element.helper';

export const tag = tagName('toaster-stack');

const styles: Array<CSSResult> = [];

styles.push(css`
  :host {
    ::slotted(a-toaster-message) {
      margin-block-start: ${spacing(150)};
    }
  }

  :host(.float) {
    inset-block: 0;
    inset-block-end: 0;
    inset-inline-end: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-block-end: ${spacing(150)};
    position: fixed;
  }

  @media (width >= ${unsafeCSS(BreakpointSmall)}) {
    :host {
      padding-inline-end: ${spacing(150)};
    }
  }
`);

export const toasterStackStyles = styles;
